import { render, staticRenderFns } from "./BOMItemForm.vue?vue&type=template&id=812b02cc&"
import script from "./BOMItemForm.vue?vue&type=script&lang=js&"
export * from "./BOMItemForm.vue?vue&type=script&lang=js&"
import style0 from "./BOMItemForm.vue?vue&type=style&index=0&id=812b02cc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports